// extracted by mini-css-extract-plugin
module.exports = {"row":"LanguageDropDown_row__31kS9","shortcut":"LanguageDropDown_shortcut__21NtC"};